import { createDefaultParagraph } from './paragraph';
import { createDefaultText } from './text';
import type {
  InlineInstructionFieldElement,
  InlineInstructionFieldVariant,
  TOCElement,
  TocStyle,
} from '../internal';
import { generateLocationId, instructionFieldElementType, TOC_STYLES } from '../internal';

export function createDefaultInlineInstructionField(
  instruction: InlineInstructionFieldVariant
): InlineInstructionFieldElement {
  return {
    children: [createDefaultText()],
    instruction,
    suggestedEdits: [],
    switches: '',
    type: instructionFieldElementType,
  };
}

export function createDefaultToc(tocStyle: TocStyle): TOCElement {
  return {
    children: [createDefaultParagraph()],
    instruction: 'TOC',
    locationId: generateLocationId(),
    options: {
      headingStyleRange: '1-3',
      hyperlink: true,
      ...(tocStyle === TOC_STYLES.links ? { pageNumbersEntryLevelsRange: '1-3' } : {}),
      useAppliedParagraphOutlineLevel: true,
    },
    suggestedEdits: [],
    switches: '',
    type: instructionFieldElementType,
  };
}
